import { createAction } from '@reduxjs/toolkit';
import { LoginRequest } from '../../interfaces/api-request/login-request.interface';
import { IUser } from '../../interfaces/user/user.interface';

export type CheckPasswordRequest = {
	password: string;
}

export const SET_LOADING = 'SET_LOADING';
export const GET_LOGIN_AUTH = 'GET_LOGIN_AUTH';
export const SET_LOGIN_AUTH = 'SET_LOGIN_AUTH';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
export const CHECK_PASSWORD = 'CHECK_PASSWORD';
export const SET_CHECK_PASSWORD = 'SET_CHECK_PASSWORD';
export const SET_CHECK_PASSWORD_ERROR = 'SET_CHECK_PASSWORD_ERROR';

export const getLoginAction = createAction<LoginRequest>(GET_LOGIN_AUTH);
export const setLoginAction = createAction<IUser>(SET_LOGIN_AUTH);
export const setLoginSuccessAction = createAction<string>(SUCCESS_LOGIN);
export const setLoginErrorAction = createAction<string>(SET_LOGIN_ERROR);
export const checkPasswordAction = createAction<CheckPasswordRequest>(CHECK_PASSWORD);
export const setCheckPasswordAction = createAction<boolean>(SET_CHECK_PASSWORD);
export const setCheckPasswordErrorAction = createAction<string>(SET_CHECK_PASSWORD_ERROR);
